// extracted by mini-css-extract-plugin
export var mainContentWithGlobal = "k_V";
export var rootPath = "k_T";